import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    templateUrl: './scheduler.component.html',
    styleUrls: ['./scheduler.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SchedulerComponent {}
